"use client";

import { getSessionData } from "@repo/shared-utils/common-utils";
import { useEffect, useState } from "react";
import { LOGGED_IN_GREETING, LOGGED_IN_GREETING_WO_NAME } from "../../constants/HeaderConstants";

const FirstName = () => {
  const [fName, setFName] = useState<string | null>(null);

  // Effect
  useEffect(() => {
    (async () => {
      const { firstName } = await getSessionData();
      if (firstName) {
        setFName(firstName);
      }
    })();
  }, []);

  return <>{fName ? `${LOGGED_IN_GREETING} ${fName}` : `${LOGGED_IN_GREETING_WO_NAME}`}</>;
};

export default FirstName;
